import { Spin } from 'antd';
import { Empty } from 'antd';
import { Divider } from 'antd';
import IS from 'react-infinite-scroll-component';

const InfiniteScroll = ({ children, ...props }) => {
  return (
    <IS
      loader={
        <Divider plain>
          <Spin spinning={true} size="large" />
        </Divider>
      }
      endMessage={
        props?.dataLength ? (
          <Divider plain>
            <span className="text-label-medium">Chưa có dữ liệu mới</span>
          </Divider>
        ) : (
          <div className="flex self-stretch items-center justify-center grow">
            <Empty />
          </div>
        )
      }
      scrollableTarget="scrollableDiv"
      {...props}
    >
      {children}
    </IS>
  );
};

export default InfiniteScroll;
